import { gql, useMutation } from "@apollo/client";

import { GET_USER_PROFILE } from "./useUserProfileQuery";

const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation update_user_profile($input: UserProfileInput!) {
    update_user_profile(input: $input) {
      is_has_buyer_agent_stale
      is_financing_status_stale
    }
  }
`;

const useUpdateUserProfileMutation = () =>
  useMutation(UPDATE_USER_PROFILE_MUTATION, {
    refetchQueries: [{ query: GET_USER_PROFILE }]
  });

export default useUpdateUserProfileMutation;
